// import './App.css';

import './styles.css';
import './views/ApplyJob/applyJob.css';
import './version1/views/login/user/candidate/CandidateLogin.css';
import './version1/views/login/user/recruiter/RecruiterLogin.css';
import 'toastr/build/toastr.min.css';

import {

  Routes,
  Route,
  Navigate,
  HashRouter as Router,
} from 'react-router-dom';
// New import for Webinar component
const Webinar = React.lazy(() => import('./version1/components/Pages/webinar/Webinar'));
const GettingStartedGuide = React.lazy(() => import('./version1/components/Pages/customer/GettingStartedGuide'));
const FAQTroubleshooting = React.lazy(() => import('./version1/components/Pages/customer/FAQTroubleshooting'));
const FeatureTutorials = React.lazy(() => import('./version1/components/Pages/customer/FeatureTutorials'));
const ProductUpdates = React.lazy(() => import('./version1/components/Pages/customer/ProductUpdates'));
const ComplianceSecurity = React.lazy(() => import('./version1/components/Pages/customer/ComplianceSecurity'));
const ResponsibleAi = React.lazy(() => import('./version1/components/Pages/ResponsibleAI/ResponsibleAi'));

import React, { Suspense, lazy } from 'react';

const About = lazy(() => import('./views/About').then(module => ({ default: module.About })));
const Contact = lazy(() => import('./views/Contact').then(module => ({ default: module.Contact })));
const Details = lazy(() => import('./views/Details').then(module => ({ default: module.Details })));
const ApplyJob = lazy(() => import('./views/ApplyJob/ApplyJob').then(module => ({ default: module.ApplyJob })));


const AboutUs = lazy(() => import('./version1/components/Pages/AboutUS/AboutUs'));
const CustomerSupportWithAuth = lazy(() => import('./version1/components/Pages/customer/CustomerSupportWithAuth'));
const CandidateLogin = lazy(() => import('./version1/views/login/user/candidate/CandidateLogin').then(module => ({ default: module.CandidateLogin })));
const CandidateSignUp = lazy(() => import('./version1/views/login/user/candidate/CandidateSignUp'));
const RecruiterLogin = lazy(() => import('./version1/views/login/user/recruiter/RecruiterLogin').then(module => ({ default: module.RecruiterLogin })));





const JobsListView = lazy(() => import('./views/JobsListView').then(module => ({ default: module.JobsListView })));
const Login = lazy(() => import('./Login'));


import ScrollToTop from './components/ScrollToTop';
// import HomeContainer from './views/containers/HomeContainer';
const PostJobContainer = lazy(() => import('./views/containers/PostJobContainer'));
const LocationsView = lazy(() => import('./views/Locations').then(module => ({ default: module.LocationsView })));
const CategoriesView = lazy(() => import('./views/CategoriesView').then(module => ({ default: module.CategoriesView })));

import { history } from './helpers/history';
const ViewSelection = lazy(() => import('./views/ViewSelection').then(module => ({ default: module.ViewSelection })));
const CandidateView = lazy(() => import('./views/CandidateView').then(module => ({ default: module.CandidateView })));
const VendorView = lazy(() => import('./views/VendorView').then(module => ({ default: module.VendorView })));
const LoginView = lazy(() => import('./views/LoginView').then(module => ({ default: module.LoginView })));
// import { VendorHistory } from './views/VendorHistory';
const PositionsHistory = lazy(() => import('./views/PositionsHistory'));
const AppliedHistory = lazy(() => import('./views/AppliedHistoryView').then(module => ({ default: module.AppliedHistory })));
const VendorViewPage = lazy(() => import('./views/vendor/vendorview').then(module => ({ default: module.VendorViewPage })));
// import { VendorTest } from './views/vendor/vendortest';
const VendorViewHistory = lazy(() => import('./views/vendor/vendorHistory').then(module => ({ default: module.VendorViewHistory })));
const DashboardView = lazy(() => import('./views/vendor/vendorDashboard').then(module => ({ default: module.DashboardView })));
const CandidateViewPage = lazy(() => import('./views/candidate/CandidateView').then(module => ({ default: module.CandidateViewPage })));
// import { CandidateDashboard } from './views/candidate/Dashboard';
const VendorJobCategories = lazy(() => import('./views/vendor/components/JobCategories').then(module => ({ default: module.VendorJobCategories })));

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setUserSession } from './actions/actions';
import { getProfile, getToken, hasJWT } from './helpers/hasToken';
import { setAuthToken } from './helpers/setAuthToken';
const LandingPage = lazy(() => import('./version1/views/home/landingPage').then(module => ({ default: module.LandingPage })));

import SessionTimeout from './components/SessionTimeout';


// import { AppHeader } from './version1/views/home/appHeader';
const AllJobs = lazy(() => import('./version1/views/allJobs/view').then(module => ({ default: module.AllJobs })));
const JobDetails = lazy(() => import('./version1/views/jobDetails/view').then(module => ({ default: module.JobDetails })));
const ExploreLocationsList = lazy(() => import('./version1/views/exploreLocations/view').then(module => ({ default: module.ExploreLocationsList })));
const ExploreCategoriesList = lazy(() => import('./version1/views/exploreCategories/view').then(module => ({ default: module.ExploreCategoriesList })));


const AdminHome = lazy(() => import('./version1/views/admin/home/view').then(module => ({ default: module.AdminHome })));

const AllJobsHistory = lazy(() => import('./version1/views/admin/allJobsHistory/view').then(module => ({ default: module.AllJobsHistory })));

const VendorEntryPage = lazy(() => import('./version1/views/admin/entryPage/view').then(module => ({ default: module.VendorEntryPage })));
const Dashboard = lazy(() => import('./version1/components/CandidateDashboard/dashboard/Dashboard'));
const DashboardContent = lazy(() => import('./version1/components/CandidateDashboard/DashboardContent'));
import Appliedjobs from './version1/components/CandidateDashboard/appliedjobs/Appliedjobs';
import SavedJobs from './version1/components/CandidateDashboard/savedjobs/SavedJobs';
import AIRecommended from './version1/components/CandidateDashboard/airecommendedjobs/AIRecommended';
const SkillsGap = React.lazy(() => import('./version1/components/CandidateDashboard/skillsGap/SkillsGap'));
const Profilepage = lazy(() => import('./version1/components/CandidateDashboard/profilepage/Profilepage'));
const JobsFullCalendar = lazy(() => import('./version1/views/admin/fullCalendar/view').then(module => ({ default: module.JobsFullCalendar })));
const ApplyNewJob = lazy(() => import('./version1/views/applyJob/view').then(module => ({ default: module.ApplyNewJob })));

import { PrivateRoute } from './PrivateRoute';

const PostNewJob = lazy(() => import('./version1/views/admin/postNewJob/view').then(module => ({ default: module.PostNewJob })));

const BlogsCasestudies = lazy(() => import('./version1/components/Pages/BlogsCasestudies/BlogsCasestudies'));


// import BlogCaseStudies from './version1/components/BlogCaseStudies/BlogCaseStudies';





const Leadership = lazy(() => import('./version1/components/Pages/Leadership/Leadership'));



// import { AppFooter } from './version1/views/home/appFooter';
// import { AdminFooter } from './version1/views/admin/entryPage/footer';
import { RouterLayout } from './RouterLayout';
const UserVerfication = lazy(() => import('./version1/views/verification/view').then(module => ({ default: module.UserVerfication })));
const BlockUserVerfication = lazy(() => import('./version1/views/verification/blockUserEmail').then(module => ({ default: module.BlockUserVerfication })));
const GenerateFiles = lazy(() => import('./version1/views/generateCareerPositions/view').then(module => ({ default: module.GenerateFiles })));
const UserResetForm = lazy(() => import('./version1/views/reset/view').then(module => ({ default: module.UserResetForm })));
const ResetPassword = lazy(() => import('./version1/views/reset/resetPassword').then(module => ({ default: module.ResetPassword })));
const EditJobDetailsID  = lazy(() => import('./version1/views/admin/allJobsHistory/EditjobDetails/view.js'));
const EmployeeManager = lazy(() => import('./version1/views/admin/employeemanagement/employeeManager.js').then(module => ({ default: module.EmployeeManager })));
const RecruiterVerification = lazy(() => import('./components/RecruiterVerification').then(module => ({ default: module.RecruiterVerification })));

const WhyRecruitPro = lazy(() => import('./version1/components/Pages/WhyRecruitPro/WhyRecruitPro'));
const FAQs = lazy(() => import('./version1/components/Pages/FAQs/FAQs'));
const JobseekerFaq = lazy(() => import('./version1/components/Pages/FAQs/JobseekerFaq'));
const TermsConditions = lazy(() => import('./version1/components/Pages/TermsCondition/TermsConditions'));
const FreeTrial = lazy(() => import('./version1/components/Pages/FreeTrial/FreeTrial.js'));

const SalesInquiry = lazy(() => import('./version1/components/Pages/SalesInquiry/SalesInquiry'));
const EnterPriseAiAccess = lazy(() => import('./version1/views/EnterPriseAiAccess'));
const EmployeeResetAccountPasswordForm = lazy(() => import('./EmployeeResetAccountPasswordForm'));
const ProductDocs = lazy(() => import('./version1/views/ProductDocs'));
const CareerBuilder = lazy(() => import('./version1/components/Pages/CareerBuilder/CareerBuilder'));
const FeedbackForm = lazy(() => import('./version1/components/Pages/FeedbackForm/FeedbackForm'));
const ApiAccess = lazy(() => import('./version1/components/Pages/ApiAcess/ApiAccess'));
const ContactLocation = lazy(() => import('./version1/components/Pages/ContactLocation/ContactLocation'));
const PrivacyPolicy = lazy(() => import('./version1/components/Pages/PrivacyPolicy/PrivacyPolicy'));
const CookiePolicy = lazy(() => import('./version1/components/Pages/TermsCondition/CookiePolicy'));

const JobseekerGovcon = lazy(() => import('./version1/components/Pages/JobseekerGovcon/JobseekerGovcon'));
const EmployerGovcon = lazy(() => import('./version1/components/Pages/EmployerGovcon/EmployerGovcon.js'));

import { HelmetProvider } from 'react-helmet-async';

// const allowedOrigins = ["http://localhost:3000", "http://localhost:8080"];

export const App = () => {
  const dispatch = useDispatch();
  const userSession = useSelector(state => state.userSession);

  // Restore user session from token on app load/refresh
  useEffect(() => {
    const token = getToken();
    if (token) {
      setAuthToken(token); // Set axios Authorization header after refresh
      if (!userSession || Object.keys(userSession).length === 0) {
        const profile = getProfile();
        if (profile) {
          dispatch(setUserSession(profile));
        }
      }
    }
  }, [dispatch]);

  useEffect(() => {
    // execute on location change
    console.log('Location changed!', history.location);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history.location])

// useEffect(() => {
//   const checkBackendHealth = async () => {
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_SERVICE}/health`);
//       if (!response.ok) {
//         window.location.href = '/maintenance.html';
//       }
//     } catch (error) {
//       console.error('Health check failed:', error);
//       window.location.href = '/maintenance.html';
//     }
//   };

//   checkBackendHealth();
// }, []);


  return (
  <HelmetProvider>
    <Router location={history.location} navigator={history}>
      <ScrollToTop />
      <RouterLayout>
        <Suspense fallback={<div>Loading...</div>}>
          <React.Fragment>
            <SessionTimeout />
            <Routes>

              {/* <Route exact path='/' element={<HomeContainer />}></Route> */}

            <Route exact path='/' element={<LandingPage />}></Route>
            <Route exact path='/about' element={<About />}></Route>
            <Route exact path='/contact' element={<Contact />}></Route>
            <Route exact path='/apply' element={<ApplyJob />}></Route>
            {/* <Route exact path='/apply' element={!hasJWT() ? <ApplyJob /> : <Navigate to='/login' />}></Route> */}
            <Route exact path='/opening' element={<ViewSelection />}></Route>
            {/* <Route exact path='/postjob' element={<LoginView role='recruiter' />}></Route> */}
            <Route exact path='/postjob'>
              <Route path="new" element={<PostJobContainer />}></Route>
              <Route path="login" element={<LoginView role='recruiter' />}></Route>
            </Route>

          <Route path='/user/login' element={<CandidateLogin />} />
          <Route path='/user/signup' element={<CandidateSignUp />} />
          <Route path='/recruiter/login' element={<RecruiterLogin />} />


            {/* <Route exact path='/postjob/new' element={!hasJWT() ? <Navigate to='/postjob' /> : <PostJobContainer />}></Route> */}
            <Route exact path='/details' element={<Details />}></Route>
            <Route exact path='/login' element={<Login />}></Route>
            <Route exact path='/jobs' element={<JobsListView />}></Route>
            <Route exact path='/details/:id' element={<Details />}></Route>
            <Route exact path='/locations' element={<LocationsView />}></Route>
            <Route exact path='/categories' element={<CategoriesView />}></Route>
            <Route exact path='/candidate' element={<CandidateView />}></Route>
            <Route exact path='/vendor' element={<VendorView />}></Route>
            {/* <Route exact path='/profile/:id' element={<UserProfile />}></Route> */}
            <Route exact path='/postingshistory' element={<PositionsHistory />}></Route>
            <Route exact path='/appliedhistory/:id' element={<AppliedHistory />}></Route>
            <Route exact path='/candidateview' element={<CandidateViewPage />}></Route>
            <Route exact path='/alljobs' element={<AllJobs />}></Route>

            <Route exact path='/career-builder' element={<CareerBuilder />} />

            <Route path='/admin' element={<VendorViewPage />}>
              <Route index element={<Navigate to="/dashboard" />} />
              <Route path='dashboard' element={<DashboardView />}></Route>
              {/* <Route path='test' element={<VendorTest />}></Route> */}
              <Route path='history' element={<VendorViewHistory type="all" />}></Route>

              <Route path='active' element={<VendorViewHistory type="active" />}></Route>

              <Route path='inactive' element={<VendorViewHistory type="inactive" />}></Route>
              <Route path='categories' element={<VendorJobCategories />}></Route>
            </Route>

            <Route exact path='/job-details/:id/:schemaName' element={<JobDetails />}></Route>
            <Route exact path='/job-categories' element={<ExploreCategoriesList />}></Route>
            <Route exact path='/job-locations' element={<ExploreLocationsList />}></Route>
            <Route exact path='/user/reset' element={<UserResetForm role="jobseeker" />}></Route>


            <Route exact path='/user/resetprofile/:id' element={<ResetPassword role="jobseeker" />}></Route>
            <Route exact path='/recruiter/reset' element={<UserResetForm role="recruiter" />}></Route>
            <Route exact path='/recruiter/resetprofile/:id' element={<ResetPassword role="recruiter" />}></Route>
            <Route exact path='/user/verifyuser' element={<BlockUserVerfication />}></Route>
            <Route exact path='/user/verification/:id' element={<UserVerfication />}></Route>
            <Route exact path='/admin/home' element={<AdminHome />}></Route>
            <Route exact path='/admin/jobs-history' element={<AllJobsHistory />}></Route>
            <Route path='/admin-vendor' element={<VendorEntryPage />}>
                          {/* <Route index element={<Navigate to="/home" />} />  */}
              <Route index element={<AdminHome />}></Route>
              <Route path='history' element={<AllJobsHistory type="all" />}></Route>

              <Route path='active' element={<AllJobsHistory type="active" />}></Route>
              <Route path='active/edit/:jobId' element={<EditJobDetailsID />}></Route>

              <Route path='inactive' element={<AllJobsHistory type="inactive" />}></Route>
              <Route path='statushistory/:statusid' element={<VendorViewHistory type="active" statusHistory={true} />}></Route>
              <Route path='categories' element={<VendorJobCategories />}></Route>
              <Route path='calendar' element={<JobsFullCalendar />}></Route>
              <Route path='postjob' element={<PostNewJob />}></Route>
              <Route path='latestjobs' element={<GenerateFiles />}></Route>
              <Route path='employeeonboard' element={<EmployeeManager />} />
            </Route>
            <Route exact path='/appliedjobs' element={<Appliedjobs />}></Route>
            <Route path='/candidate/dashboard' element={hasJWT() ? <Dashboard /> : <Navigate to='/login' />}>
              <Route index element={<DashboardContent />} />
              <Route path='profile' element={<Profilepage />} />
              <Route path='savedjobs' element={<SavedJobs />} />
              <Route path='airecommended' element={<AIRecommended />} />
              <Route path='skillsgap' element={<SkillsGap />} />
            </Route>
            <Route exact path='/apply-job/:schemaName' element={<PrivateRoute><ApplyNewJob /></PrivateRoute>}></Route>
            {/* <Route exact path='/employeeonboard/verify-recruiter' element={<RecruiterVerification token={new URLSearchParams(window.location.search).get('token')} />} /> */}

          <Route exact
  path="/employeeonboard/verify-recruiter"
  element={
    <RecruiterVerification
      token={new URLSearchParams(window.location.hash.split('?')[1]).get('token')}
    />
  }
/>

            <Route exact path='/why-recruitpro' element={<WhyRecruitPro />} />
            <Route exact path='/help/faqs' element={<FAQs />} />
            <Route exact path='/jobseeker/faqs' element={<JobseekerFaq />} />
            <Route exact path="/jobseekers-govcon" element={<JobseekerGovcon />} />
            <Route exact path="/recruiter/Employersgovcon" element={<EmployerGovcon />} />
            <Route exact path='/terms-of-use' element={<TermsConditions />} />

            <Route exact path="/recruiter/free-trial" element={<FreeTrial />} />
            <Route exact path="/help/feedback-form" element={<FeedbackForm />} />
            <Route exact path="/api-access" element={<ApiAccess />} />
            <Route exact path="/customer-support" element={<CustomerSupportWithAuth />} />
                 <Route exact path="/about-us" element={<AboutUs />} />
            <Route exact path="/help/sales-inquiry" element={<SalesInquiry />} />
            <Route exact path="/recruiter/EnterPriseAiAccess" element={<EnterPriseAiAccess />} />

            {/* <Route exact path="/blog-case-studies" element={<BlogCaseStudies />} /> */}
            <Route exact path="/leadership" element={<Leadership />} />
            <Route exact path="/blog-case-studies" element={<BlogsCasestudies />} />

            <Route exact path="/employeeonboard/reset-password" element={<EmployeeResetAccountPasswordForm />} />
            <Route exact path='/product-docs' element={<ProductDocs />} />
            <Route exact path='/webinars-events' element={<Webinar />} />
            <Route path="*" element={<Navigate to="/" replace />} />
            <Route exact path="/contact-location" element={<ContactLocation />} />
          <Route exact path='/privacy-policy' element={<PrivacyPolicy/>} />
          <Route exact path='/cookie-policy' element={<CookiePolicy />} />
          <Route exact path="/customer/getting-started-guide" element={<GettingStartedGuide />} />
          <Route exact path="/customer/faq-troubleshooting" element={<FAQTroubleshooting />} />
          <Route exact path="/customer/feature-tutorials" element={<FeatureTutorials />} />
          <Route exact path="/customer/product-updates" element={<ProductUpdates />} />
          <Route exact path="/customer/compliance-security" element={<ComplianceSecurity />} />
          <Route exact path="/responsible-ai" element={<ResponsibleAi />} />
        </Routes>
      </React.Fragment>
    </Suspense>
    </RouterLayout>

  </Router >
  </HelmetProvider>
  );
}

export default App;
